import {Anchor} from 'src/design/atoms/Anchor';
import {Code} from 'src/design/atoms/Code';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {QRCodeSVG} from 'qrcode.react';
import {useState} from 'react';
import {CopyActionIcon} from 'src/design/molecules/CopyActionIcon';

interface TotpSetupDetailsProps {
  sharedSecret: string;
  username: string;
}

export const TotpSetupDetails = ({
  sharedSecret,
  username,
}: TotpSetupDetailsProps) => {
  const [showKey, setShowKey] = useState(false);
  const uri = `otpauth://totp/${encodeURIComponent(
    `Proact:${username}`
  )}?secret=${encodeURIComponent(sharedSecret)}&issuer=Proact`;
  return (
    <Stack gap="xs" align="flex-start">
      <QRCodeSVG
        role="img"
        aria-label="Authenticator setup QR code"
        value={uri}
        size={200}
        includeMargin
      />
      <Anchor
        component="button"
        type="button"
        size="sm"
        c="blue"
        td="hover:underline"
        onClick={() => setShowKey(open => !open)}>
        {showKey ? 'Hide the key' : 'Enter a key manually'}
      </Anchor>
      {showKey && (
        <Stack gap="xs">
          <Text size="sm">
            In your authenticator app, choose to enter a key manually and type
            this key.
          </Text>
          <Group gap="xs" wrap="nowrap">
            <Code style={{overflowWrap: 'anywhere'}}>{sharedSecret}</Code>
            <CopyActionIcon value={sharedSecret} />
          </Group>
        </Stack>
      )}
    </Stack>
  );
};
